import PageWrap from './PageWrap';

export default PageWrap;
